import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { municipalitiesManagement } from "../../../../../../hooks/api/MunicipalitiesManagement/MunicipalitiesManagement";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";

const AddMunicipality = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useAddMunicipalitiesMutation } = municipalitiesManagement;
    const [addMunicipalities, { isLoading: isAddingMunicipalities }] = useAddMunicipalitiesMutation();

    const tabs = [
        { title: t('noteTypes.title'), onClick: () => gotoNoteTypes()},
        { title: t('guardianTypes.title'), onClick: () => gotoGuardianType()},
        { title: t('municipalities.title'), isActive: true},
    ];

    const gotoGuardianType = () => {
        navigate("/settings/default/guardian-types");
    };

    const gotoNoteTypes = () => {
        navigate("/settings/default/note-types");
    };

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        if (values?.contactPerson === "") {
            values.contactPerson = null;
        }
        addMunicipalities(values).then((result) => {            
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/default/municipalities");
            }
        });
    };

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/default/municipalities" />
                <Button title={t("save")} isDisabled={isAddingMunicipalities} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("settings.default")} />
                    <Link title={t("municipalities.title")} />
                    <Link title={t("municipalities.addNew")} isActive={true} />
                </Breadcrumps>
                <Formik
                        innerRef={formRef}
                        initialValues={{
                            name: "",
                            postalCode: ""
                        }}
                        onSubmit={onSaved}
                    >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Input
                                        name="name"
                                        label={t("municipalities.name")}
                                        required={true}
                                        value={values.name}
                                        onChange={handleChange}
                                        error={formErrors?.name}
                                    />
                                </Field>   
                                <Field>
                                    <Input
                                        name="postalCode"
                                        label={t("municipalities.postalCode")}
                                        required={true}
                                        value={values.postalCode}
                                        onChange={handleChange}
                                        error={formErrors?.postalCode}
                                    />
                                </Field>                    
                            </Row>
                            
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddMunicipality;